import { useQuery } from '@tanstack/react-query';
import { MaintenancePerformanceService } from '../services/maintenance-performance.service';
import type { PerformanceFilters } from '../types/maintenance-performance.types';
import { useState } from 'react';

export function usePerformance(companyId: string, initialFilters: PerformanceFilters = {}) {
  const [filters, setFilters] = useState<PerformanceFilters>({
    period: 'month',
    ...initialFilters
  });

  const overviewQuery = useQuery({
    queryKey: ['maintenance-performance', 'overview', companyId, filters],
    queryFn: () => MaintenancePerformanceService.getOverviewStats(companyId, filters),
    enabled: !!companyId,
  });

  const teamRankingQuery = useQuery({
    queryKey: ['maintenance-performance', 'teams', companyId],
    queryFn: () => MaintenancePerformanceService.getTeamRankings(companyId),
    enabled: !!companyId,
  });

  const zonePerformanceQuery = useQuery({
    queryKey: ['maintenance-performance', 'zones', companyId, filters.projectId],
    queryFn: () => MaintenancePerformanceService.getZonePerformance(companyId, filters.projectId),
    enabled: !!companyId,
  });

  const trendQuery = useQuery({
    queryKey: ['maintenance-performance', 'trend', companyId, filters.period],
    queryFn: () => MaintenancePerformanceService.getPerformanceTrend(companyId, filters.period),
    enabled: !!companyId,
  });

  return {
    stats: overviewQuery.data,
    teamRankings: teamRankingQuery.data || [],
    zonePerformance: zonePerformanceQuery.data || [],
    trend: trendQuery.data || [],
    isLoading: overviewQuery.isLoading || teamRankingQuery.isLoading || zonePerformanceQuery.isLoading || trendQuery.isLoading,
    filters,
    setFilters,
  };
}
